import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { removeUser } from "../../../../controller/reducer/user";

const UserDeleteModal = ({ show, onClose, user, dispatch }) => {
  const deleteTask = () => {
    dispatch(removeUser(user._id))
    onClose();
  }
  return (
    <Modal show={show} animation={false} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete User </Modal.Title>
      </Modal.Header>
      <Modal.Body>Confirm Delete {user.name}</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={deleteTask}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserDeleteModal;
